import React from "react";
import * as Icon from "@phosphor-icons/react";


function Rate(props) {
    const { currentRate, size } = props
    let arrOfStar = [];
    for (let i = 0; i < 5; i++) {
        if (currentRate) {
            if (i >= currentRate) {
                arrOfStar.push(<Icon.Star key={i} size={size} color="#9FA09C" weight="fill" />);
            } else {
                arrOfStar.push(<Icon.Star key={i} size={size} color="#ECB018" weight="fill" />);
            }
        }
    }
    return <div className="rate d-flex">{arrOfStar}</div>;
}

export default Rate